/*
 * ChooseAccommodationReducer
 *
 * The reducer takes care of our data. Using actions, we can change our application state.
 * To add a new action, add it to the ACTION_HANDLERS object.
 */

// Actions
import { ROOM_TYPES, ALL } from 'utils/constants';

const SELECT_ROOM = 'app/ChooseAccommodation/SELECT_ROOM';
const UPDATE_FILTERS = 'app/ChooseAccommodation/UPDATE_FILTERS';
const SET_ROOMS = 'app/ChooseAccommodation/SET_ROOMS';
const SET_SHOULD_REFETCH = 'app/ChooseAccommodation/SET_SHOULD_REFETCH';

// The initial state of the reducer
const initialState = {
  selectedRoom: null,
  filters: {
    smoking: false,
    accessible: false,
    nonsmoking: false,
    roomType: { value: ALL, label: ROOM_TYPES.ALL }
  },
  shouldRefetch: false
};

// Action Handlers
const ACTION_HANDLERS = {
  [SELECT_ROOM]: (state, action) =>
    Object.assign({}, state, {
      selectedRoom: action.payload.room
    }),
  [UPDATE_FILTERS]: (state, action) =>
    Object.assign({}, state, {
      filters: Object.assign({}, state.filters, action.payload.filters)
    }),
  [SET_ROOMS]: (state, action) =>
    Object.assign({}, state, {
      rooms: action.payload.rooms
    }),
  [SET_SHOULD_REFETCH]: (state, action) =>
    Object.assign({}, state, {
      shouldRefetch: action.payload.shouldRefetch
    })
};

// Action Creators
export function selectRoom(room) {
  return {
    type: SELECT_ROOM,
    payload: { room }
  };
}

export function updateFilters(filters) {
  return {
    type: UPDATE_FILTERS,
    payload: { filters }
  };
}

export function setShouldRefetch(shouldRefetch) {
  return {
    type: SET_SHOULD_REFETCH,
    payload: { shouldRefetch }
  };
}

// Reducer
export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
